import { render, staticRenderFns } from "./question-and-answer-grid-06.vue?vue&type=template&id=ff60e424&scoped=true&"
import script from "./question-and-answer-grid-06.vue?vue&type=script&lang=js&"
export * from "./question-and-answer-grid-06.vue?vue&type=script&lang=js&"
import style0 from "./question-and-answer-grid-06.vue?vue&type=style&index=0&id=ff60e424&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff60e424",
  null
  
)

export default component.exports